import styled from 'styled-components';

export const DescriptionStyled = styled.div`
  border-bottom: 1px solid #a5a5a5;
  padding-bottom: 24px;
  font-size: 16px;
  line-height: 1.5;
  > p {
    margin: 0;
  }
  > p:not(:only-child) {
    margin-bottom: 16px;
    &:last-child {
      margin-bottom: 0;
    }
  }
`;
